module.exports = __webpack_public_path__ + "img/main-logo.3c94bc22.png";